<template>
  <div class="h-screen overflow-hidden flex flex-col bg-white border-solid border-l border-0 border-gray-border">
    <div class="border-solid border-b border-0 border-gray-border px-8 pb-8">
      <input-with-error-message v-if="isRenameMode"
                                id="index-editor-name-input"
                                :value.sync="botName"
                                :is-loading="isLoading"
                                @escape="$emit('set-rename-mode', false)"
                                @submit="$emit('rename',{ ...bot, name: $event })"
                                class="h-full mt-5 w-2/3"
      />
      <div v-else class="mt-8 inline-block pr-14 relative">
        <h3 class="font-semibold">
          {{ bot.name }}
        </h3>
        <side-list-menu v-if="!isRenameMode"
                        :items="menuItems"
                        class="absolute top-0 right-0 -mt-1"
                        @rename="$emit('set-rename-mode', true)"
                        @delete="$emit('request-delete', bot)"
        />
      </div>
    </div>

    <div class="h-full flex flex-col justify-between">
      <div class="mt-8 px-8 flex flex-col gap-6 text-gray-dark">
        <div>
          <label class="font-bold">Bot Type</label>
          <div class="mt-1 flex items-center gap-2">
            <span>{{ formatBotType(bot.type) }}</span>
            <vs-icon :icon="getIcon(bot.type)"/>
          </div>
        </div>

        <div>
          <label class="font-bold">Language</label>
          <div class="mt-1 flex items-center gap-2">
            <span>{{ getBotLanguage(bot.language) }}</span>
            <vs-icon icon="language"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputWithErrorMessage from '@/components/common/InputWithErrorMessage.vue'
import SideListMenu from '@/components/common/SideListMenu'
import { BOT_LANGUAGES } from '@/utils/bot.constants'
import { MENU_ITEMS } from '@/utils/editor.constants'

export default {
  name: 'SettingsBotSummary',

  components: {
    InputWithErrorMessage,
    SideListMenu
  },

  props: {
    bot: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isRenameMode: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    bot: {
      immediate: true,
      handler(bot) {
        this.botName = bot.name
      }
    }
  },

  data() {
    return {
      botName: ''
    }
  },

  computed: {
    menuItems() {
      return ['111', '222'].includes(this.bot.id) ? [MENU_ITEMS.rename] : [MENU_ITEMS.rename, MENU_ITEMS.delete]
    }
  },

  methods: {
    formatBotType(botType) {
      return botType[0].toUpperCase() + botType.slice(1)
    },
    getIcon(type) {
      return type === 'chat' ? 'message' : 'email_outline'
    },
    getBotLanguage(languageValue) {
      return BOT_LANGUAGES.find(language => language.value === languageValue)?.text
    }
  }
}
</script>
